import React from 'react';

export default function SuperAdminDashboard() {
  return <div>SuperAdminDashboard</div>;
}
